import TableVertical from "../Util/TableVertical";
import CardLayout from "../Layout/CardLayout";
import React from "react";

const InversionTotal = (ciemId) => {

    const contributionForm =
        <TableVertical optionName={"inversionTable"}
                       ciemId={ciemId}
                       editable={false}
        />
    ;

    return (
        <div className="container-fluid">
            <CardLayout value={"inversionTitulo"} tablaComponent={contributionForm} />
        </div>
    );
};
export default InversionTotal;